import React from 'react';
import { Select } from 'antd';

const CustomSelect = ({ placeholder, options, value, onChange, ...props }) => (
  <Select
    placeholder={placeholder}
    allowClear
    value={value}
    onChange={onChange}
    options={options}
    showSearch
    filterOption={(input, option) =>
      (option?.label ?? '').normalize('NFC').toLowerCase().includes(input.normalize('NFC').toLowerCase())
    }
    {...props}
  />
);

export default CustomSelect;
